// Main Typography component and types
export {
  Typography,
  type TypographyProps,
  type TypographyVariant,
  type TypographyElement,
  type TypographyColor,
  type TypographyWeight,
  type TypographyFamily,
  type TypographyAlign,
  type TypographyTransform,
  type TypographyDecoration,
  type ResponsiveProp,
  type DisplayVariant,
  type TextVariant,
} from './Typography';

// Convenience components
export {
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Heading5,
  Heading6,
  BodyLarge,
  Body,
  BodySmall,
  Caption,
  Label,
  Code,
} from './Typography';

// Examples

// Default export
export { Typography as default } from './Typography';
